import styles from './Slideshow.module.css';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Arrow from '../assets/arrowTopRight.jsx';
import { useParams } from "react-router-dom";

function Slideshow({ title, items }) {

    const { lang } = useParams();

    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        fade: true,
        arrows: false,
        pauseOnFocus: true,

        // adaptiveHeight: false,
        appendDots: dots => (
            <div>
                <ul>{dots}</ul>
            </div>
        ),
        customPaging: i => (
            <div style={{ width: '100px', height: '2px', backgroundColor: 'white' }}></div>
        )
    }
    return (
        <div className={`${styles.slideshow} ${lang === "ko" && styles.lang_ko}`}>
            <Slider {...settings}>
                {items.map((item, i) => {

                    const getMediaType = (url) => {
                        if (!url) return null;
                        const extension = url.split('.').pop().toLowerCase();
                        const videoExtensions = ['mp4', 'webm', 'ogg', 'mov'];
                        const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'webp'];

                        if (videoExtensions.includes(extension)) return 'video';
                        if (imageExtensions.includes(extension)) return 'image';
                        return null;
                    };

                    const mediaType = getMediaType(item.fields.media.fields.file.url);
                    const key = item?.sys?.id ?? i;
                    const motifColor = item.fields.motifColor?.value || 'white';

                    return (
                        <div className={styles.slide} key={key}>
                            <p>{item.fields.cornerText}</p>
                            {mediaType === "video" && (
                                <video className={styles.video} autoPlay loop muted playsInline>
                                    <source src={item.fields.media.fields.file.url} type="video/mp4" />
                                </video>
                            )}

                            {mediaType === "image" && (
                                <img
                                    className={styles.image}
                                    src={item.fields.media.fields.file.url}
                                    alt={item.fields.title}
                                />
                            )}

                            <h2 className="preserve-line-breaks">{item.fields.headline ? item.fields.headline : item.fields.title}</h2>

                            <a href={item.fields.link} style={{ backgroundColor: motifColor }} className={styles.cta}>
                                <p style={{ color: item.fields.ctaTextColor?.value }}>
                                    <span>{item.fields.ctaText}</span>
                                    <Arrow color="#fafafa" />
                                </p>
                            </a>
                            <div className={styles.pixel} style={{ backgroundColor: motifColor }}></div>
                            <div className={styles.pixel} style={{ backgroundColor: motifColor }}></div>
                        </div >
                    );
                })}

            </Slider>
        </div>
    );
}

export default Slideshow;